const CDN_LOGO_PATH = 'https://cdn.ecoonline.com/assets/logos/brand/colour'

export const DEFAULT_LOGOMARK_SRC = `${CDN_LOGO_PATH}/logomark.svg`
export const DEFAULT_LOGO_SRC = `${CDN_LOGO_PATH}/logo.svg`

export const DEFAULT_HELP_URL = 'https://help.ecoonline.com'
